import * as React from 'react';
import { Navigate, Route, Routes } from 'react-router';
import PageLayout from 'v2/layout/PageLayout/PageLayout';
import NotFound from 'v2/pages/GeneralErrors/NotFound';
import MyDevice from './MyDevice/MyDevice';

const MyProfile: React.FC = () => {
  return (
    <PageLayout>
      <Routes>
        <Route path="/my-device" element={<MyDevice />} />
        <Route path="/" element={<Navigate to="/my-profile/my-device" replace />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </PageLayout>
  );
};

export default MyProfile;
